<!-- <ng-template #modal size="sm">
    <ng-content></ng-content>
</ng-template> -->

<sc-modal [size]="size" #modal>
    <ng-content></ng-content>
</sc-modal>